<template>
  <div :style="customStyles" class="min-h-screen">
    <EmbedAvailableToday/>
  </div>
</template>

<script setup lang="ts">
import { useReferralStore } from '~/stores/referralStore';

// Use clean embed layout. Pin to light: partner iframes live on arbitrary
// external sites where following the visitor's OS dark preference could clash.
definePageMeta({
  layout: 'embed',
  colorMode: 'light'
});

const route = useRoute();
const referralStore = useReferralStore();

// Extract color parameters from URL query
const backgroundColor = route.query.bg ? '#' + route.query.bg : '#ffffff';
const primaryColor = route.query.primary ? '#' + route.query.primary : '#1d4ed8';
const secondaryColor = route.query.secondary || '#6b7280';

// Capture and store referral partner code from query param
// Support both "ref" and "r" parameters, with "ref" taking priority
const referralCode = route.query.ref || route.query.r;
if (referralCode) {
  referralStore.setPartnerCode(referralCode);
}

// Create dynamic CSS custom properties
const customStyles = computed(() => ({
  backgroundColor: backgroundColor,
  '--color-primary-900': primaryColor,
  '--color-primary-700': primaryColor,
  '--color-blue-700': primaryColor,
  '--color-blue-600': primaryColor,
  '--color-blue-800': primaryColor,
  // '--color-gray-500': secondaryColor,
  // '--color-gray-400': secondaryColor,
  // '--color-gray-900': secondaryColor
}));

// Set page title and meta for embedding
useHead({
  title: 'Properties available for 1 month+ rent',
  meta: [
    { name: 'robots', content: 'noindex, nofollow' }
  ]
});
</script>

<style scoped>
/* Override component styles with CSS variables */
:deep(.bg-primary-900) {
  background-color: var(--color-primary-900) !important;
}

:deep(.text-primary-900) {
  color: var(--color-primary-900) !important;
}

:deep(.bg-blue-700) {
  background-color: var(--color-blue-700) !important;
}

:deep(.bg-blue-600) {
  background-color: var(--color-blue-600) !important;
}

:deep(.hover\\:bg-blue-800:hover) {
  background-color: var(--color-blue-800) !important;
}

:deep(.text-gray-500) {
  color: var(--color-gray-500) !important;
}

:deep(.text-gray-400) {
  color: var(--color-gray-400) !important;
}

:deep(.text-gray-900) {
  color: var(--color-gray-900) !important;
}
</style>